<template>
  <div v-loading="loading" class="project-live-container simple-search-table-container">
    <div class="head flex-align-center">
      <div style="display: flex;align-items: center;">
        <el-date-picker v-model="query.dates" type="monthrange" range-separator="至" start-placeholder="直播月份开始"
                        end-placeholder="直播月份结束" size="mini" style="width: 250px;margin-right: 10px;" clearable
                        value-format="yyyy-MM-dd" @change="handelSearch"/>
        <select-customer-mine :name.sync="query.customer_name" size="mini" style="width: 200px" @change="handelSearch"/>
        <select-artist :value.sync="query.artist_id" size="mini" style="width: 200px" @change="handelSearch"/>
        <el-input v-model="query.order_no" clearable placeholder="全案订单编号" size="mini" style="width: 200px;"
                  @change="handelSearch"/>
        <el-button type="primary" size="mini" icon="el-icon-search" @click="handelSearch" style="margin-left: 10px;">
          查询
        </el-button>

        <export-by-page module="ORDER_LIVE_REPORT" :search="query" style="margin-left: 8px"/>

      </div>
      <div class="flex-align-center">
        <el-button icon="el-icon-refresh" type="text" circle :disabled="doLoading" :loading="doLoading"
                   @click="handleRunScript" style="padding:0;margin-right: 4px;"/>
        <span class="tip-time" v-if="tableData[0]">
          最后更新时间：{{ tableData[0].updated_at }}
        </span>
        <span v-else class="tip-time">暂无数据</span>
      </div>
    </div>
    <div style="height: calc(100% - 190px)">
      <el-table :data="tableData" height="calc(100% - 16px)" @sort-change="eventSortMethod">
        <el-table-column label="#" type="index"/>
        <el-table-column label="直播记录" min-width="130" show-overflow-tooltip>
          <template v-slot="{row:{customer_name,nickname,live_date,live_promotion}}">
            <div class="over-hidden">时间：{{ live_date|parseTime('{y}年{m}月') }}</div>
            <div class="over-hidden">红人：{{ nickname }}</div>
            <div class="over-hidden">客户：{{ customer_name }}</div>
          </template>
        </el-table-column>
        <el-table-column label="全案信息" min-width="130" show-overflow-tooltip>
          <template v-slot="{row:{order_no,product,brand,sale_name}}">
            <div>单号：
              <to-order-detail by-field="order_no" :order="{order_no}"/>
            </div>
            <div>产品： {{ product }}</div>
            <div>品牌： {{ brand }}</div>
            <div>销售： {{ sale_name }}</div>
          </template>
        </el-table-column>
        <el-table-column label="直播机制" prop="live_sm" align="center">
          <template v-slot="{row:{live_sm}}">
            <el-tooltip class="item" effect="dark" :content="live_sm" placement="top">
              <div class="live-sm">
                {{ live_sm }}
                <div class="live-sm__mark" @click="copy(live_sm)">
                  <span>复制</span>
                </div>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="直播佣金" prop="live_c_rate" align="center" sortable>
          <template v-slot="{row:{live_c_rate}}">
            <b>{{ live_c_rate|numberFormat(2) }} %</b>
          </template>
        </el-table-column>
        <el-table-column label="直播销量" prop="live_sales_qty" header-align="right" align="right" min-width="90"
                         sortable>
          <template v-slot="{row:{live_sales_qty}}">
            <b>{{ live_sales_qty|numberFormat }}</b>
          </template>
        </el-table-column>
        <el-table-column label="直播销售额" prop="live_gmv" header-align="right" align="right" min-width="90" sortable>
          <template v-slot="{row:{live_gmv}}">
            {{ live_gmv|numberFormat(2) }}
          </template>
        </el-table-column>
        <el-table-column label="直播次数" prop="live_count" header-align="right" align="right" min-width="90" sortable>
          <template v-slot="{row:{live_count}}">
            <b>{{ live_count|numberFormat }}</b>
          </template>
        </el-table-column>
        <el-table-column label="保量/主次推" min-width="100" align="center">
          <template v-slot="{row:{is_quantity,is_quantity_times,gq_amount,live_promotion}}">
            <div v-if="is_quantity==='Y'">
              <span class="tag">
                保量:￥{{ gq_amount|numberFormat(2) }}
              </span>
            </div>
            <div v-if="is_quantity_times==='Y'">
              <span class="tag">保次</span>
            </div>
            <span v-if="live_promotion" class="tag">{{ live_promotion }}</span>
          </template>
        </el-table-column>
        <!--        <el-table-column label="销售" prop="sale_name" align="center"/>-->
        <el-table-column label="全案总含税收入" prop="payment_account" header-align="right" align="right"
                         min-width="100"
                         sortable>
          <template v-slot="{row:{payment_account}}">
            <b>￥{{ payment_account|numberFormat(2) }}</b>
          </template>
        </el-table-column>
        <el-table-column label="子订单编号" align="center" min-width="130">
          <template v-slot="{row:{children_order_no}}">
            <div v-if="children_order_no">
              <to-order-detail v-for="child in children_order_no.split(',')" :key="child" :order="{order_no:child}"
                               by-field="order_no"/>
            </div>
            <div v-else style="color: #999;text-align: center;">暂无</div>
          </template>
        </el-table-column>
        <el-table-column label="子订单信息" min-width="130" show-overflow-tooltip>
          <template v-slot="{row:{children_order_no,cart_commission,exec_price,_platforms}}">
            <template v-if="children_order_no">
              <div>总坑位费：<b>￥ {{ cart_commission|numberFormat(2) }}</b></div>
              <div>总执行价：<b>￥ {{ exec_price|numberFormat(2) }}</b></div>
              <div>平台：<b>{{ _platforms }}</b></div>
            </template>
            <div v-else style="color: #999;text-align: center;">暂无</div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          :current-page="query.page"
          :page-size="query.page_size"
          layout="total, prev, pager, next"
          :total="query.total"
          style="margin-top: 10px;float: right;"
          @current-change="handleCurrentChange"
      />
    </div>
    <div class="tip-help">
      统计说明：<br>
      数据行维度：全案营销主单号下，所有直播数据以"不同红人"，“直播时间”按月汇总，对应已执行的子订单按“执行时间”按月汇总（同月）；<br>
      如：一个全案订单，有3条直播数据，1月份2条(两个红人1人1条)，2月份1条，显示为3行数据；<br>
      本表以填写的直播数据为主，右边汇总同月已执行的子订单维度；<br>
    </div>
  </div>
</template>

<script>
import SelectCustomerMine from "@/components/Selects/customer.vue";
import ToOrderDetail from "@/views/adOrder/components/ToDetail.vue";
import SelectArtist from "@/components/Selects/artist.vue";
import {reportOrderLiveData, runReportOrderLiveScript} from "@/api/order";

import moment from "moment";
import {copy} from "@/utils";
import ExportByPage from "@/components/export/ByPage/index.vue";

export default {
  components: {ExportByPage, SelectArtist, ToOrderDetail, SelectCustomerMine},
  data() {
    return {
      copy,
      tableData: [],
      loading: false,
      doLoading: false,
      query: {
        page: 1,
        page_size: 20,
        total: 0,
        order_by: null,

        dates: [],
        customer_name: null,
        artist_id: null,
        order_no: null
      },
    }
  },
  created() {
    this.getTableData(true)
  },
  methods: {
    eventSortMethod: function ({order, prop}) {
      let string = null;
      switch (order) {
        case 'descending':
          string = `${prop} desc`
          break;
        case 'ascending':
          string = `${prop} asc`
          break;
        default:
          break;
      }
      this.query.order_by = string
      this.getTableData(true)
    },
    handelSearch: function () {
      this.getTableData(true)
    },
    handleCurrentChange: function (page) {
      this.query.page = page
      this.getTableData()
    },
    getTableData: async function (is_search = false) {
      // 查询重置 page
      is_search && (this.query.page = 1)

      this.loading = true
      const response = await reportOrderLiveData(this.query)
      this.loading = false
      this.tableData = response.model.data || []
      this.query.total = response.model.total || 0
    },
    changeTableSort(_) {
      const {prop, order} = _
      let order_by = null
      if (order) {
        order_by = order === 'ascending' ? `\`${prop}\` asc` : `\`${prop}\` desc`
      }
      this.queryParams.order_by = order_by
      this.getTableData()
    },
    /**
     * 获取中间的月份区间
     * @returns {[{month: number, year: number},{month: number, year: number}]|*[]}
     */
    getMonths() {
      const {dates} = this.query
      if (Array.isArray(dates) && dates.length === 2) {
        const month_s = moment(dates[0])
        const month_e = moment(dates[1])
        const months = []
        months.push({year: month_s.format('YYYY'), month: month_s.format('MM'),})
        while (month_s.add(1, 'months').isBefore(month_e)) {
          months.push({
            year: month_s.format('YYYY'),
            month: month_s.format('MM'),
          })
        }
        months.push({year: month_e.format('YYYY'), month: month_e.format('MM'),})
        return months
      } else {
        return [
          {year: moment().subtract(1, 'months').year(), month: (moment().subtract(1, 'months').month()) + 1},
          {year: moment().year(), month: moment().month() + 1},
        ]
      }
    },
    async handleRunScript() {
      const params = this.getMonths()
      //执行权限更新
      const string_s = `${params[0].year}年${params[0].month}月`;
      const string_e = `${params[params.length - 1].year}年${params[params.length - 1].month}月`;
      const string_rang = string_s === string_e ? string_e : `${string_s}~${string_e}`
      this.$confirm(
        `确定更新<b>${string_rang}</b>数据吗？`,
        '更新直播汇总数据',
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(async () => {
          this.doLoading = true

          await runReportOrderLiveScript(params)
          this.msgSuccess('更新任务已发布，请稍后点击查询是否更新')

          setTimeout(() => {
            this.doLoading = false
          }, 500)
        })
    }
  }
}
</script>

<style lang="scss">
.project-live-container {
  padding: 24px;

  .el-table .red-row {
    background: #ffeeee;
  }

  .el-table thead tr, .el-table thead th {
    background: white !important;
    color: #3c3c3c !important;
    font-weight: 600;
  }

  .flag-error {
    display: inline-block;
    width: auto;
    line-height: 17px;
    padding: 0 10px;
    border-radius: 9px;
    //border: 1px solid #ab0707;
    color: #FFFFFF;
    background-color: #ab0707;
    font-size: 12px;
    cursor: pointer;
  }

  .head {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;

    .el-select {
      //width: 250px;
      margin-right: 12px;
    }
  }

  .ape-table-container {
    height: calc(100% - 206px) !important;
  }

  .tip-time {
    color: #8a8e99;
    font-size: 12px;
    margin-right: 10px;
  }

  .tip-help {
    margin-top: 40px;
    margin-bottom: 10px;
    padding: 8px 24px;
    overflow-y: auto;
    background-color: #FFF9FBFC;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    line-height: 22px;
    color: #666;
    border-radius: 9px;
    position: relative;
    box-sizing: border-box;
    height: 110px;
  }

  .tag {
    border-radius: 3px;
    background-color: #ffeef3;
    color: #fe346e;
    font-size: 12px;
    padding: 0 8px;
    height: 20px;
    line-height: 20px;
  }

  .el-table .cell {
    height: auto !important;
  }

  .el-table th.el-table__cell > .cell {
    min-height: 34px !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .el-table .sort-caret.ascending {
    top: 7px !important;
  }

  .el-table .sort-caret.descending {
    bottom: 5px !important;
  }

  .over-hidden {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .live-sm:hover {
    .live-sm__mark {
      opacity: .7 !important;
    }
  }

  .live-sm {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    position: relative;
    cursor: pointer;

    &__mark {
      position: absolute;
      width: 100%;
      height: 100%;
      background: #111;
      opacity: 0;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius: 4px;

      span {
        color: #FFFFFF;
        cursor: pointer;
      }
    }
  }
}
</style>
